var moment = require('moment-jalaali')

function FormatDate(){
    return function (inputDate, format) {
        var date = moment(inputDate,format);
        return date.format(format);
    }
}

module.exports = ngModule => {
    ngModule.filter('FormatDate', FormatDate);
};